import React, { useState } from "react";
import { TableContext } from "../../index";
import PaginationManager from "../../view/PaginationManager";
import { debug } from "../../utils";
import { getCentralCredentialsPaginated } from "../authService";
import CentralCredentialsCardModal from "./CentralCredentialsCardModal";
import CentralCredentialsTableHeader from "./CentralCredentialsTableHeader";
import CentralCredentialsTable from "./CentralCredentialsTable";
import { ChevronDown } from "lucide-react";

function CentralCredentialsTableSection(props) {

    const [showModal, setShowModal] = useState(false);
    const [modalProps, setModalProps] = useState({});
    const [collapsed, setCollapsed] = useState(false);


    const handleShowModal = (props) => {
        setModalProps(props);
        setShowModal(true);
    }

    const initTableConfig = {
        selected: [],
        isLoading: true,
        showModal: handleShowModal,
        collapsed,
        setCollapsed,
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    const onCloseModal = (shouldRefresh = false) => {
        if (shouldRefresh) {
            setTableConfig(prev => ({ ...prev, lastUpdated: Date.now() }));
        }
        setShowModal(false);
    }

    return (
        <>
            {showModal && <CentralCredentialsCardModal handleClose={onCloseModal} {...modalProps} />}
            <TableContext.Provider value={{ config: { ...tableConfig, collapsed, setCollapsed }, setConfig: changeTableConfig }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card oct_analysis-card-v2 p-0">
                                <button
                                    className="oct_settings-section-header w-100 border-0 p-4"
                                    onClick={() => setCollapsed(!collapsed)}
                                >
                                    <h3>Centralized Credentials</h3>
                                    <ChevronDown
                                        className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}
                                    />
                                </button>
                                <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
                                    <CentralCredentialsTableHeader />
                                    <div className="card-body pt-0">
                                        <div className="dataTables_wrapper dt-bootstrap4 no-footer mt-3">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <CentralCredentialsTable />
                                                    <PaginationManager getPage={getCentralCredentialsPaginated} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </TableContext.Provider>
        </>
    )
}

export default CentralCredentialsTableSection;
